import { render, staticRenderFns } from "./FilaRecetaOriginal.vue?vue&type=template&id=1336087c"
import script from "./FilaRecetaOriginal.vue?vue&type=script&lang=js"
export * from "./FilaRecetaOriginal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports